import { closestCenter, DndContext, PointerSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy, } from '@dnd-kit/sortable';
import React, { useMemo } from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import CustomScrollView from 'src/components/10-atoms/list-views/CustomScrollView';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import styleUtils from 'src/utils/styles';
import EmptyTabsList from './EmptyTabsList';
import TabItem from './TabItem';
const TabsList = ({ tabs, editable = true, activeTabID, onTabChange, onAddTab, onEditTab, onDeleteTab, onViewHistory, onRearrangeTabs, tabAllowsHistory, getTabTo, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const isSortable = editable && !!onRearrangeTabs;
    const tabIDs = useMemo(() => tabs.map((tab) => tab.id), [tabs]);
    const sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: { distance: 5 },
    }));
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (over && active.id !== over.id) {
            const oldIndex = tabs.findIndex((tab) => tab.id === active.id);
            const newIndex = tabs.findIndex((tab) => tab.id === over.id);
            const reordered = arrayMove(tabs, oldIndex, newIndex);
            onRearrangeTabs(reordered.map((tab) => tab.id));
        }
    };
    const tabItems = tabs.map((tab) => (React.createElement(TabItem, { key: tab.id, tab: tab, isActive: activeTabID === tab.id, editable: editable, sortable: isSortable, to: getTabTo?.(tab.id), onTabChange: onTabChange, onEditTab: onEditTab, onDeleteTab: onDeleteTab, onViewHistory: onViewHistory && (tabAllowsHistory ? tabAllowsHistory(tab) : true)
            ? onViewHistory
            : undefined })));
    return (React.createElement(CustomScrollView, { containerStyle: styleUtils.flex },
        React.createElement(Column, { flex: true, pv: theme.spacing.standard.sm }, tabs.length === 0 ? (React.createElement(EmptyTabsList, { editable: editable, onAddTab: onAddTab })) : isSortable ? (React.createElement(DndContext, { sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd },
            React.createElement(SortableContext, { items: tabIDs, strategy: verticalListSortingStrategy }, tabItems))) : (tabItems))));
};
const stylesGenerator = createThemedStyle(() => ({}));
export default TabsList;
